export default __webpack_public_path__ + "static/media/banner_ihelp3.24c34d58.jpg";